module.exports = __webpack_public_path__ + "static/foundstages-logo-trans-bkgd-632ed7e066523b5701c1022f4c74be9e.png";